(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-zh-prelaunch]').forEach((section) => {
      if (section.dataset.clockInitialized) return;
      section.dataset.clockInitialized = 'true';
      const end = Date.parse(section.dataset.launch || '');
      const clock = section.querySelector('.zh-prelaunch__countdown');
      const parts = ['d', 'h', 'm', 's'].map((key) => section.querySelector(`[data-zh="${key}"]`));
      if (!Number.isFinite(end) || parts.some((part) => !part)) {
        if (clock) clock.hidden = true;
        return;
      }
      let timer = null;
      const tick = () => {
        const diff = Math.max(0, end - Date.now());
        const values = [Math.floor(diff / 86400000), Math.floor(diff % 86400000 / 3600000),
          Math.floor(diff % 3600000 / 60000), Math.floor(diff % 60000 / 1000)];
        parts.forEach((part, index) => {
          const next = String(values[index]).padStart(2, '0');
          if (part.textContent !== next) part.textContent = next;
        });
        if (diff === 0 && timer) clearInterval(timer);
      };
      tick();
      if (Date.now() < end) timer = setInterval(tick, 1000);
      section.addEventListener('zh:clock-dispose', () => clearInterval(timer), {once: true});
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-zh-prelaunch]').forEach((section) => {
      section.dispatchEvent(new Event('zh:clock-dispose'));
    });
  });
})();
